module.exports = __webpack_public_path__ + "static/step-2-2133b8a418fdff16552b6044657841dd.jpg";